import { store } from "../store/index";
import { getVisualMainQueue, synchronizeData } from "../store/actions/VisualMainQueueActions";

/**
 * Update Farm
 */
export const synchData = async () => {
  const objSend = {};
  const result = await store.dispatch(synchronizeData(objSend));
  if (result?.payload?.data) {
    return "OK";
  }
  return null;
};


export const listVisualMainQueue = async (filter) => {
  const result = await store.dispatch(getVisualMainQueue(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
